import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { RequestParams, ResponseCatalog } from 'Models'
import { ArchiveBrokerOrder, OrderRefusalStatuses, OrderStatus } from 'Pages/archiveBroker'
import { Callback } from 'Src/types/utilTypes'
import { BgRequestNs } from 'Pages/ibro'

interface InitialState {
	data: ResponseCatalog<ArchiveBrokerOrder>
	currentOrder: ArchiveBrokerOrder | null
	requestParams: RequestParams
	orderRefusalStatuses: OrderRefusalStatuses[]
	orderStatuses: OrderStatus[]
}

const initialState: InitialState = {
	data: new ResponseCatalog<ArchiveBrokerOrder>(),
	currentOrder: null,
	requestParams: new RequestParams(),
	orderRefusalStatuses: [],
	orderStatuses: [],
}

export namespace ArchiveBrokerNS {
	export type GetAll = PayloadAction<{
		params?: RequestParams
		clear?: boolean
		callback?: Callback
	}>
	export type SetAll = PayloadAction<ResponseCatalog<ArchiveBrokerOrder>>
	export type SetRequestParams = PayloadAction<RequestParams>
	export type GetOne = PayloadAction<{
		id: string
	}>
	export type SetOne = PayloadAction<ArchiveBrokerOrder>
	export type SetOrderRefusalStatuses = PayloadAction<OrderRefusalStatuses[]>
	export type GetOrderStatuses = PayloadAction<{
		params: RequestParams
	}>
	export type SetOrderStatus = PayloadAction<OrderStatus[]>
	export type SendReport = PayloadAction<{
		params?: RequestParams
	}>
	export type GetContactUser = PayloadAction<{
		id: string
	}>
}

export const archiveBrokerSlice = createSlice({
	name: 'archiveBroker',
	initialState,
	reducers: {
		getAll: (state, action: ArchiveBrokerNS.GetAll) => {},
		setAll: (state, action: ArchiveBrokerNS.SetAll) => {
			state.data = action.payload
		},
		clearAll: (state) => {
			state.data = new ResponseCatalog<ArchiveBrokerOrder>()
			state.requestParams = new RequestParams()
		},
		getOne: (state, action: ArchiveBrokerNS.GetOne) => {},
		setOne: (state, action: ArchiveBrokerNS.SetOne) => {
			state.currentOrder = action.payload
		},
		setRequestParams: (state, action: BgRequestNs.SetRequestParams) => {
			state.requestParams = action.payload
		},
		clearStore: (state) => {
			return initialState
		},
		setOrderRefusalStatuses: (state, action: ArchiveBrokerNS.SetOrderRefusalStatuses) => {
			state.orderRefusalStatuses = action.payload
		},
		getOrderStatuses: (state, action: ArchiveBrokerNS.GetOrderStatuses) => {},
		setOrderStatuses: (state, action: ArchiveBrokerNS.SetOrderStatus) => {
			state.orderStatuses = action.payload
		},
		getDicts: () => {},
		sendReport: (state, action: ArchiveBrokerNS.SendReport) => {},
		getUserContact: (state, action: ArchiveBrokerNS.GetContactUser) => {},
	},
})
